<template>
    <q-card class="bg-grey-1">
        <q-card-main class="relative-position cursor-pointer">
            <div class="line-card bg-primary absolute-top"></div>

            <div class="row q-my-sm">
                <div class="col-3" @click="openCourse()">
                    <img class="training-thumb" :src="presential.image_small ? presential.image_small : getPlaceholder">
                </div>

                <div class="col-8" @click="openCourse()">
                    <div class="row">
                        <div class="col-12 q-title text-weight-medium text-primary">
                            {{ presential.title }}
                        </div>

                        <div class="col-12 q-mb-md">
                            <q-rating color="amber" slot="subtitle" icon="fas fa-star" v-model="presential.stars_rating" :max="5" readonly />
                        </div>

                        <div class="col-12" v-if="presential.tags.length > 0 && current_client !== 'academiacoral' ">
                            <p class="caption">
                                {{ $t('tags') }}
                            </p>
                            <p class="tooltip q-mb-sm">
                                <span v-for="(tag, index) in presential.tags" :key="index">
                                    {{ getTag(tag) }}<span v-if="(presential.tags.length - 1) > index">, </span>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-1 text-center" @click="handleProgressIconClick()">
                    <vc-donut v-if="presential.user_progress <= 0" :sections="getSections" :size="100" unit="%">
                        <q-icon :name="getIconProgress" :color="getIconColor" size="2rem" />
                    </vc-donut>
                    <vc-donut v-else-if="presential.presential_event_user_result_status === 1" :sections="getSections" :size="100" unit="%">
                        <q-icon :name="getIconProgress" :color="getIconColor" size="2rem" />
                    </vc-donut>
                    <vc-donut v-else-if="presential.presential_event_user_result_status === 2" :sections="getSections" :size="100" unit="%">
                        <q-icon :name="getIconProgress" :color="getIconColor" size="2rem" />
                    </vc-donut>
                    <vc-donut v-else-if="presential.user_progress > 0 && presential.status === 5" :sections="getSections" :size="100" unit="%">
                        <q-icon :name="getIconProgress" :color="getIconColor" size="2rem" />
                    </vc-donut>
                    <vc-donut v-else :sections="getSections" :size="100" unit="%">
                        <h6 :class="presential.is_blocked ? 'text-faded' : 'text-primary'">
                            {{ getPercentage(presential.user_progress) }}%
                        </h6>
                    </vc-donut>
                </div>
            </div>
        </q-card-main>

        <q-card-separator />

        <q-card-actions>
            <p class="text-center fit">
                <q-btn flat v-for="(action, index) in actions" :key="index" :icon="action.icon" color="primary" :label="getLabel(action.label)" v-if="showAction(action.slug)" :color="getColor(action.slug)" @click="doAction(action.slug)">
                    <q-tooltip>
                        {{ $t(action.tooltip) }}
                    </q-tooltip>
                </q-btn>
            </p>
        </q-card-actions>

        <q-card-separator v-if="showSubscribeButton" />

        <q-card-actions v-if="showSubscribeButton">
            <q-btn :color="getSubscribeButtonColor" class="full-width" :label="$t(getSubscribeButtonLabel)" :icon="getSubscribeButtonIcon" @click="showCourseInfo(presential)" />
        </q-card-actions>
    </q-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { debounce, date } from 'quasar'
const { getDateDiff, formatDate } = date

export default {
    props: ['presential', 'current_client'],

    data() {
        return {
            selected_client_params: [],
            sections: [],
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            all_tags: 'site_lists/tags',
            all_areas: 'site_lists/country_areas',
            group_users: 'site_lists/group_users_labels',
            clients: 'params/clients',
            params_loaded: 'params/params_loaded',
			id_user_client_selected: 'common/id_user_client_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getPlaceholder() {
            if (!this.selected_client_params.presential_event_placeholder) return ''
            else return this.selected_client_params.presential_event_placeholder
        },

        showSubscribeButton() {
            if (this.presential.status === 8) return false
            if (this.presential.presential_event_type === 1) return true
            else return false
        },

        getSubscribeButtonLabel() {
            if (!this.presential.user_subscribed && this.presential.vacancies <= 0) return 'no_vacancy'
            else if (!this.presential.user_subscribed) return 'subscribe'
            else return 'unsubscribe'
        },

        getSubscribeButtonIcon() {
            if (!this.presential.user_subscribed && this.presential.vacancies <= 0) return 'fas fa-users-slash'
            else if (!this.presential.user_subscribed) return 'fas fa-sign-in-alt'
            else return 'fas fa-sign-out-alt'
        },

        getSubscribeButtonColor() {
            if (!this.presential.user_subscribed && this.presential.vacancies <= 0) return 'negative'
            else if (!this.presential.user_subscribed) return 'primary'
            else return 'tertiary'
        },

        getSections() {
            if (!this.presential.user_subscribed) return [{value: 0, color: '#21ba45'}]
            else if (this.presential.presential_event_user_result_status === 1) return [{value: 100, color: '#21ba45'}]
            else if (this.presential.presential_event_user_result_status === 2) return [{value: 100, color: '#e53935'}]
            else if (this.presential.user_progress > 99) return [{value: 100, color: '#21ba45'}]
            else if (this.presential.user_progress > 0 && this.presential.user_progress <= 99) return [{value: parseInt(this.presential.user_progress), color: '#21ba45'}]
            else {
                switch(this.presential.status) {
                    case 1: return [{value: parseInt(this.presential.user_progress), color: '#e6ee9c'}]
                    break
                    case 2: return [{value: parseInt(this.presential.user_progress), color: '#4dd0e1'}]
                    break
                    case 3: return [{value: parseInt(this.presential.user_progress), color: '#31ccec'}]
                    break
                    case 4: return [{value: parseInt(this.presential.user_progress), color: '#aaa'}]
                    break
                    case 5: return [{value: parseInt(this.presential.user_progress), color: '#23a3dd'}]
                    break
                    case 6: return [{value: parseInt(this.presential.user_progress), color: '#db2828'}]
                    break
                    case 7: return [{value: parseInt(this.presential.user_progress), color: '#424242'}]
                    break
                    case 8: return [{value: parseInt(this.presential.user_progress), color: '#21ba45'}]
                    break
                    default: return []
                    break
                }
            }
        },

        getIconProgress() {
            if (this.presential.presential_event_user_result_status === 1) return 'fas fa-trophy'
            else if (this.presential.presential_event_user_result_status === 2) return 'fas fa-ban'
            else {
                switch(this.presential.status) {
                    case 1: return 'fas fa-history'
                    break
                    case 2: return 'far fa-clock'
                    break
                    case 3: return 'fas fa-play'
                    break
                    case 4: return 'fas fa-pause'
                    break
                    case 5: return 'fas fa-clipboard-check'
                    break
                    case 6: return 'far fa-times-circle'
                    break
                    case 7: return 'fas fa-ban'
                    break
                    case 8: return 'fas fa-check'
                    break
                    default: return ''
                    break
                }
            }
        },

        getIconColor() {
            if (this.presential.presential_event_user_result_status === 1) return 'green-7'
            else if (this.presential.presential_event_user_result_status === 2) return 'red-7'
            else {
                switch(this.presential.status) {
                    case 1: return 'yellow'
                    break
                    case 2: return 'purple-4'
                    break
                    case 3: return 'indigo'
                    break
                    case 4: return 'grey-7'
                    break
                    case 5: return 'yellow-10'
                    break
                    case 6: return 'dark'
                    break
                    case 7: return 'red-7'
                    break
                    case 8: return 'green-7'
                    break
                    default: return ''
                }
            }
        },

        actions() {
            let actions = []
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if(obj) {
                actions.push({
                    icon: 'fas fa-trophy',
                    label: 'score',
                    tooltip: 'score',
                    slug: 'score'
                })
                actions.push({
                     icon: 'far fa-thumbs-up',
                    label: 'likes',
                    tooltip: 'like',
                    slug: 'likes'
                })
                if(obj.use_comments_presential) {
                    actions.push({
                        icon: 'far fa-star',
                        label: 'stars',
                        tooltip: 'add_comment',
                        slug: 'stars'
                    })
                }
                actions.push({
                    icon: 'far fa-heart',
                    label: 'favorite',
                    tooltip: 'add_favorite',
                    slug: 'favorite'
                })
            }
            return actions
        }
    },

    methods: {
        handleProgressIconClick() {
            if(this.presential.status === 5 && !this.presential.approved) {
                this.$q.notify({
                    message: this.$t('training_not_finished_please_wait'),
                    type: 'warning',
                    icon: 'fas fa-user-clock'
                })
                return
            }
            else if (this.presential.status === 8 && this.presential.approved) {
                this.$emit('showCertificate', this.presential.id)
            }
        },

        showCourseInfo(course) {
            if (!this.presential.user_subscribed && this.presential.vacancies <= 0)return
            else this.$emit('showCourseInfo', course)
        },

        subscribePresentialTraining() {
            this.$emit('subscribe_presential_training')
        },

        getArea(id) {
            let obj = this.all_areas.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getGroup(id) {
            let obj = this.group_users.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getTag(id) {
            let obj = this.all_tags.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        showAction(slug) {
            if (slug == 'score') {
                if (!this.selected_client_params.group_training_use_score) return false
                else return true
            }
            else {
                return true
            }
        },

        getPercentage(percentage) {
            if (!percentage) {
                return 0
            }
            else if (percentage <= 100) {
                return parseInt(percentage)
            }
        },

        getColor(slug) {
            if (slug == 'likes') {
                if (this.presential.liked) return 'secondary'
                else return ''
            }
            else if (slug == 'stars') {
                if (this.presential.starred) return 'secondary'
                else return ''
            }
            else if (slug == 'favorite') {
                if (this.presential.favorited) return 'negative'
                else return ''
            }
            else {
                return ''
            }
        },

        doAction(slug) {
            if (slug == 'likes') {
                this.likeItem()
            }
            else if (slug == 'stars') {
                this.$emit('clickStars', this.presential.id)
            }
            else if (slug == 'favorite') {
                this.favoriteItem()
            }
        },

        getLabel(label) {
            switch(label) {
                case 'score': return this.presential.score
                break
                case 'likes': return this.presential.likes
                break
                case 'stars': return `${this.presential.avg_stars} / 5`
                break
            }
        },

        openCourse() {
            this.$router.push({ name: 'view_presential', params: { id: this.presential.id } })
        }
    },

    created() {
        let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
        this.selected_client_params = client ? client : {}
    },

    mounted() {
        this.likeItem = debounce(() => {
            this.$emit('clickLike', this.presential.id)
        }, 500)

        this.favoriteItem = debounce(() => {
            this.$emit('clickFavorite', this.presential.id)
        }, 500)
    }
}
</script>

<style lang="stylus" scoped>
.line-card
    border-top: 3px solid transparent
    border-top-left-radius inherit
    border-top-right-radius inherit

p
    margin 0 0 5px

.training-thumb
    width 90%
    height auto
    border-radius 10px
</style>
